// TemplatePanel.jsx
// Panel for template-level settings (subject line, preheader, etc.)
import React from 'react';
import SubjectLineEditor from './ConfigurationPanel/input-panels/helpers/inputs/SubjectLineEditor.tsx';
import { useTemplateMetadata } from '../../../configuration/sections/communications/TemplateMetadataContext';

const TemplatePanel = () => {
  const { subject, onSubjectChange } = useTemplateMetadata();

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 overflow-auto p-4 space-y-6">
        {/* Subject Line Section */}
        <div>
          <h3 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground mb-3">
            Subject Line
          </h3>
          <div className="subject-line-wrapper">
            <style>{`
              .subject-line-wrapper .subject-line-editor {
                max-height: none !important;
                min-height: 38px;
              }
              .subject-line-wrapper .subject-line-editor p {
                white-space: normal !important;
                overflow: visible !important;
                text-overflow: clip !important;
                display: block !important;
              }
            `}</style>
            <SubjectLineEditor
              defaultValue={subject}
              onChange={onSubjectChange}
              placeholder="Enter subject line..."
            />
          </div>
        </div>

        {/* Future: Add preheader, from name, etc. here */}
      </div>
    </div>
  );
};

export default TemplatePanel;
